import {
  Accordion as MuiAccordion,
  AccordionSummary as MuiAccordionSummary,
  AccordionDetails as MuiAccordionDetails
} from '@material-ui/core';
import styled from 'styled-components';

const Accordion = styled(MuiAccordion)`
  border: 1px solid #eee !important ;
  box-shadow: none !important;
`;

const AccordionSummary = styled(MuiAccordionSummary)`
  background: ${(props) => props.$backgroundColor ?? '#efefef'} !important;
  border-radius: 0.25rem !important;
`;

const AccordionDetails = styled(MuiAccordionDetails)`
  display: grid !important;
  width: 100%;
`;

const QuestionContainer = styled.div`
  display: grid;
  width: 100%;
  background: yellow;
`;

export const ConfigSurvey = {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  QuestionContainer
};
